module.exports = __webpack_public_path__ + "img/operation-hover.14ecda19.svg";